import {useState, useEffect, useContext} from 'react';
import AjaxRequester from "../Utils/AjaxRequester.js";
import {APP} from "../Utils/Constants.js";
import {DataPageContext} from "../Context/DataPageContext.tsx"

const extractId = (idString: string) => {
  const match = idString.match(/\/(\d+)/);
  return match ? parseInt(match[1], 10) : null;
};

/**
 * Retrieve the data necessary to build filters & query.
 */
const getOriginalDatas = async (dataPage: string) => {

  const goalValue = () => dataPage === 'node-page-117'
    ? 'ss_field_formation_category:qualifying'
    : 'ss_field_formation_category:qualifying_enterprise';

    const paramsArray = AjaxRequester.getTaxonomyTermSolrParams(['type_formation', 'domain_formation']);
    const response = await AjaxRequester.getFromSolr(paramsArray);
    const transformedData = response.grouped.ss_vid.groups.reduce((accumulator: { [x: string]: any; }, current: { groupValue: string | number; doclist: any; }) => {
        accumulator[current.groupValue] = current.doclist;
        return accumulator;
    }, {});

    const placesResponse = await AjaxRequester.getFromSolr([{
      name: 'q',
      value: 'index_id:node'
    },
      {
        name: 'fq',
        value: 'ss_type:training_center'
      }, {
        name: 'rows',
        value: 100
      }, {
        name: 'fl',
        value: 'id,tcphoneticm_X3b_fr_title, ss_field_slug'
      }
    ]);
  const placesTransformedArray = placesResponse.response.docs
    // Map to the new structure
    .map((doc: { id: string; tcphoneticm_X3b_fr_title: any[]; ss_field_slug: any; }) => ({
      id: extractId(doc.id), // Extract the numerical ID
      name: doc.tcphoneticm_X3b_fr_title[0], // Assuming the name is the first item in the title array
      slug: doc.ss_field_slug
    }))
    // Sort by name
    .sort((a: { name: string; }, b: { name: any; }) => a.name.localeCompare(b.name, 'fr')); // Use French locale for accurate sorting

  const prices = await AjaxRequester.getFromSolr([
    {
      name: 'q',
      value: 'index_id:product'
    },
    {
      name: 'rows',
      value: 0
    },
    {
      name: 'fq',
      value: goalValue()
    },
    {
      name: 'stats',
      value: true
    },
    {
      name: 'stats.field',
      value: 'itm_variation_prices'
    }
  ]);

  const stores = await AjaxRequester.getFromSolr([
    {
      name: 'q',
      value: 'index_id:stores'
    }
  ])

  return {
        typeFormation: AjaxRequester.convertSolrTermToJsonApi(transformedData['type_formation'].docs),
        domains: AjaxRequester.convertSolrTermToJsonApi(transformedData['domain_formation'].docs),
        places: placesTransformedArray,
        prices: prices.stats.stats_fields.itm_variation_prices,
        stores: stores.response.docs
    };
};


export const useOriginalDatas = () => {
    const { dataPage } = useContext(DataPageContext);

    const [dataStatus, setDataStatus] = useState(APP.STATUS.LOADING)
    const [originalDatas, setOriginalDatas] = useState<OriginalDatas>({
        typeFormation: [],
        domains: [],
        places: [],
        prices: [],
        stores: [],
    });
  const fetchData = async () => {

    try {
      const data = await getOriginalDatas(dataPage);

      setOriginalDatas(data);
      setDataStatus(APP.STATUS.LOADED)
    } catch (error) {
      console.error(error);
    }
  };

    useEffect(() => {
        fetchData();
    }, [dataPage]);

    return { originalDatas, dataStatus };
};
